import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Toast,
  Spinner,
  Button,
  PageActions,
  DataTable,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useParams } from "react-router-dom";
import Select2 from "react-select";
import { STATUS } from "rsuite/esm/internals/constants";
import { useNavigate, useLocation } from "react-router-dom";

const EditTransaction = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(false);
  const [user, setUser] = useState("");
  const [item, setItem] = useState({
    // payment_type: "",
    // type: "",
    amount: "",
    status: "",
  });

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "Changes have been done successfully"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [remainingBookings, setRemainingBookings] = useState("");
  const [pivotId, setPivotId] = useState("");
  const handleChangeRemainingBookings = (newValue) => {
    setItem({ ...item, remaining_bookings: newValue });
    setRemainingBookingsError("");
  };
  const [remainingBookingsError, setRemainingBookingsError] = useState("");
  const handleChangeStartDate = (newValue) => {
    setItem({ ...item, start_date: newValue });
  };
  const handleSelectChangePaymentType = (newValue) => {
    setItem({ ...item, payment_type: newValue });
  };
  const handleSelectChangeType = (newValue) => {
    setItem({ ...item, type: newValue });
  };
  const handleChangeAmount = (newValue) => {
    setItem({ ...item, amount: newValue });
  };
  const handleSelectChangeAction = (newValue) => {
    setItem({ ...item, status: newValue });
  };
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(`/transactions/${id}`);
      console.log("test=", response?.data?.data?.type);
      setItem({
        amount:
          response?.data?.data?.amount !== null
            ? String(response?.data?.data?.amount)
            : "",
        // payment_type: response?.data?.data?.payment_type
        //   ? response?.data?.data?.payment_type
        //   : "",
        // type: response?.data?.data?.type ? response?.data?.data?.type : "",
      });
    } catch (error) {
      console.log(error);
    }

    setIsSaving(false);
  }
  const [error, setError] = useState("");
  return (
    <Page
      narrowWidth
      backAction={{
        onAction: () => {
          navigate(`/admin/bookings`);
        },
      }}
      title="Edit Transaction"
    >
      <Card>
        <FormLayout>
          <TextField
            value={item.amount}
            onChange={handleChangeAmount}
            label="Amount"
          />
          <Select
            label="Action"
            options={[
              // { label: "Pending", value: "pending" },
              { label: "Cancel with refund", value: "cancelled" },
              {
                label: "Cancel with no refund",
                value: "cancelled with no refund",
              },
            ]}
            onChange={handleSelectChangeAction}
            value={item.status}
            placeholder="Please select"
          />
          {/* <Select
            label="Payment Type"
            disabled
            options={[
              // { label: "Pending", value: "pending" },
              { label: "Wallet", value: "wallet" },
              { label: "Card", value: "card" },
              {
                label: "Offline Card",
                value: "offline_card",
              },
              {
                label: "Cash",
                value: "cash",
              },
              {
                label: "Credits",
                value: "credits",
              },
              {
                label: "other",
                value: "other",
              },
            ]}
            onChange={handleSelectChangePaymentType}
            value={item.payment_type}
            placeholder="Please select"
          />

          <Select
            disabled
            label="Type"
            options={[
              // { label: "Pending", value: "pending" },
              { label: "Book Session", value: "Book Session" },
              { label: "Package Purchase", value: "Package Purchase" },
              {
                label: "Membership Purchase",
                value: "Membership Purchase",
              },
              {
                label: "Top Up Wallet",
                value: "Top Up Wallet",
              },
              {
                label: "Book Retreat'",
                value: "Book Retreat'",
              },
            ]}
            onChange={handleSelectChangeType}
            value={item.type}
            placeholder="Please select"
          /> */}
          <InlineError message={error} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    console.log(item);

    setIsSaving(true);
    axios
      .patch(`/transactions/${id}`, {
        amount: item.amount,
        action: item.status,
        // payment_type: item.payment_type,
        // type: item.type,
      })
      .then((result) => {
        setIsSaving(false);
        toggleActive();
      })
      .catch(function (error) {
        console.log("error=", error.response.data.message);
        setError(error.response.data.message);
        setIsSaving(false);
      });
  }
};

export default EditTransaction;
